export function formatDate(date: string, format?: string) {
  const dateObj = new Date(date)
  
  if (format === 'europe') {
    // European format: dd/mm/yy
    const day = dateObj.getDate().toString().padStart(2, '0')
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
    const year = dateObj.getFullYear().toString().slice(-2)
    return `${day}/${month}/${year}`
  }
  
  // Default US format
  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

export function daysAgo(date: string) {
  const diffTime = Math.abs(Date.now() - new Date(date).getTime())
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`
}

/** "3 days ago (November 1, 2026)" — same format as Campus. */
export function formatDateWithDaysAgo(date: string) {
  return `${daysAgo(date)} (${formatDate(date)})`
}